
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7y6O1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $2tuSz = parcelRequire("2tuSz");

var $lUcpS = parcelRequire("lUcpS");


var $cP7Ln = parcelRequire("cP7Ln");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bhxnw = parcelRequire("bhxnw");


var $iVhFD = parcelRequire("iVhFD");


var $7iexr = parcelRequire("7iexr");


var $dvJQW = parcelRequire("dvJQW");


var $54JrL = parcelRequire("54JrL");


var $5Vf10 = parcelRequire("5Vf10");

/**
 * A wrapper component that displays a team profile card in a popup when a trigger element
 * is interacted with (hover or click).
 *
 * This component loads the team profile card content lazily using an entry point, displays
 * loading and error states, and tracks analytics events for user interactions. The card data
 * is fetched from GraphQL when the popup is triggered.
 */ const $6527e90b2c09ca30$var$TeamProfileCardWithTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamProfileCardWithTrigger(t0) {
    const $ = (0, $bDgLe.c)(40);
    const { teamAri: teamAri, cloudId: cloudId, containerId: containerId, userId: userId, showFlag: showFlag, trigger: trigger, placement: t1, shouldRenderToParent: t2, children: children, additionalActions: additionalActions, townsquareApp: townsquareApp, headingAs: headingAs } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const shouldRenderToParent = t2 === undefined ? false : t2;
    const fireEvent = (0, $bhxnw.useAnalyticsEventsWithDuration)();
    const { fireEvent: fireAnalyticsEvent } = (0, $lUcpS.useAnalyticsEvents)();
    let t3;
    if ($[0] !== fireEvent) {
        t3 = ()=>{
            fireEvent("ui.teamProfileCard.rendered.errorBoundary", $6527e90b2c09ca30$var$_temp);
        };
        $[0] = fireEvent;
        $[1] = t3;
    } else t3 = $[1];
    const onErrorBoundary = t3;
    let t4;
    if ($[2] !== fireEvent) {
        t4 = (t5)=>{
            const { error: error, errorInfo: errorInfo } = t5;
            const { name: errorType, message: errorMessage, ...errorRest } = error;
            fireEvent("operational.teamProfileCard.failed.request", (duration_0)=>({
                    duration: duration_0,
                    firedAt: Math.round((0, $7iexr.getPageTime)()),
                    gateway: true,
                    errorCategory: null,
                    errorNumber: null,
                    errorPath: null,
                    errorStatusCode: null,
                    isSLOFailure: true,
                    traceId: null,
                    errorType: errorType,
                    errorMessage: errorMessage,
                    errorStack: errorInfo.componentStack ?? null,
                    ...errorRest
                }));
            fireEvent("ui.teamProfileCard.rendered.error", $6527e90b2c09ca30$var$_temp2);
        };
        $[2] = fireEvent;
        $[3] = t4;
    } else t4 = $[3];
    const onError = t4;
    let t5;
    if ($[4] !== fireAnalyticsEvent || $[5] !== teamAri) {
        t5 = (method)=>{
            fireAnalyticsEvent("ui.teamProfileCard.triggered", {
                method: method,
                firedAt: Math.round((0, $7iexr.getPageTime)()),
                teamId: teamAri
            });
        };
        $[4] = fireAnalyticsEvent;
        $[5] = teamAri;
        $[6] = t5;
    } else t5 = $[6];
    const onOpen = t5;
    if (!teamAri || !cloudId) {
        let t6;
        if ($[7] !== children) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[7] = children;
            $[8] = t6;
        } else t6 = $[8];
        return t6;
    }
    let t6;
    if ($[9] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[9] = children;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54JrL.CardLoading), null);
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== cloudId || $[13] !== teamAri) {
        t8 = {
            cloudId: cloudId,
            teamId: teamAri
        };
        $[12] = cloudId;
        $[13] = teamAri;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== additionalActions || $[16] !== cloudId || $[17] !== containerId || $[18] !== headingAs || $[19] !== showFlag || $[20] !== townsquareApp || $[21] !== userId) {
        t9 = {
            cloudId: cloudId,
            containerId: containerId,
            userId: userId,
            showFlag: showFlag,
            additionalActions: additionalActions,
            townsquareApp: townsquareApp,
            headingAs: headingAs
        };
        $[15] = additionalActions;
        $[16] = cloudId;
        $[17] = containerId;
        $[18] = headingAs;
        $[19] = showFlag;
        $[20] = townsquareApp;
        $[21] = userId;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $jp2Q3.layers).modal();
        $[23] = t10;
    } else t10 = $[23];
    const t11 = trigger ?? "hover";
    let t12;
    if ($[24] !== children || $[25] !== trigger) {
        t12 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Vf10.TeamProfileCardTrigger), {
                trigger: trigger,
                triggerProps: triggerProps
            }, children);
        $[24] = children;
        $[25] = trigger;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== onError || $[28] !== onOpen || $[29] !== placement || $[30] !== shouldRenderToParent || $[31] !== t11 || $[32] !== t12 || $[33] !== t8 || $[34] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cP7Ln.PopupTriggerWithHover), {
            entryPoint: (0, $iVhFD.entryPoint),
            placement: placement,
            fallback: t7,
            onError: onError,
            onOpen: onOpen,
            errorFallback: (0, $dvJQW.CardError),
            entryPointParams: t8,
            entryPointProps: t9,
            shouldRenderToParent: shouldRenderToParent,
            shouldUseCaptureOnOutsideClick: true,
            zIndex: t10,
            triggerMode: t11,
            trigger: t12
        });
        $[27] = onError;
        $[28] = onOpen;
        $[29] = placement;
        $[30] = shouldRenderToParent;
        $[31] = t11;
        $[32] = t12;
        $[33] = t8;
        $[34] = t9;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== onErrorBoundary || $[37] !== t13 || $[38] !== t6) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            onError: onErrorBoundary,
            fallback: t6
        }, t13);
        $[36] = onErrorBoundary;
        $[37] = t13;
        $[38] = t6;
        $[39] = t14;
    } else t14 = $[39];
    return t14;
} : function TeamProfileCardWithTrigger({ teamAri: teamAri, cloudId: cloudId, containerId: containerId, userId: userId, showFlag: showFlag, trigger: trigger, placement: placement = 'bottom-start', shouldRenderToParent: shouldRenderToParent = false, children: children, additionalActions: additionalActions, townsquareApp: townsquareApp, headingAs: headingAs }) {
    const fireEvent = (0, $bhxnw.useAnalyticsEventsWithDuration)();
    const { fireEvent: fireAnalyticsEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.teamProfileCard.rendered.errorBoundary', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $7iexr.getPageTime)())
            }));
    }, [
        fireEvent
    ]);
    const onError = (0, $cozmU.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        const { name: errorType, message: errorMessage, ...errorRest } = error;
        fireEvent('operational.teamProfileCard.failed.request', (duration_0)=>({
                duration: duration_0,
                firedAt: Math.round((0, $7iexr.getPageTime)()),
                gateway: true,
                errorCategory: null,
                errorNumber: null,
                errorPath: null,
                errorStatusCode: null,
                isSLOFailure: true,
                traceId: null,
                errorType: errorType,
                errorMessage: errorMessage,
                errorStack: errorInfo.componentStack ?? null,
                ...errorRest
            }));
        fireEvent('ui.teamProfileCard.rendered.error', (duration_1)=>({
                duration: duration_1,
                firedAt: Math.round((0, $7iexr.getPageTime)())
            }));
    }, [
        fireEvent
    ]);
    const onOpen = (0, $cozmU.useCallback)((method)=>{
        fireAnalyticsEvent('ui.teamProfileCard.triggered', {
            method: method,
            firedAt: Math.round((0, $7iexr.getPageTime)()),
            teamId: teamAri
        });
    }, [
        fireAnalyticsEvent,
        teamAri
    ]);
    if (!teamAri || !cloudId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cP7Ln.PopupTriggerWithHover), {
        entryPoint: (0, $iVhFD.entryPoint),
        placement: placement,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54JrL.CardLoading), null),
        onError: onError,
        onOpen: onOpen,
        errorFallback: (0, $dvJQW.CardError),
        entryPointParams: {
            cloudId: cloudId,
            teamId: teamAri
        },
        entryPointProps: {
            cloudId: cloudId,
            containerId: containerId,
            userId: userId,
            showFlag: showFlag,
            additionalActions: additionalActions,
            townsquareApp: townsquareApp,
            headingAs: headingAs
        },
        shouldRenderToParent: shouldRenderToParent,
        shouldUseCaptureOnOutsideClick: true,
        zIndex: (0, $jp2Q3.layers).modal(),
        triggerMode: trigger ?? 'hover',
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Vf10.TeamProfileCardTrigger), {
                trigger: trigger,
                triggerProps: triggerProps
            }, children)
    }));
};
function $6527e90b2c09ca30$var$_temp2(duration_1) {
    return {
        duration: duration_1,
        firedAt: Math.round((0, $7iexr.getPageTime)())
    };
}
function $6527e90b2c09ca30$var$_temp(duration) {
    return {
        duration: duration,
        firedAt: Math.round((0, $7iexr.getPageTime)())
    };
}
const $6527e90b2c09ca30$export$d5b7952f9e2934c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            source: "teamProfileCardTrigger",
            attributes: {
                isRenderedByTrigger: true
            }
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2tuSz.TeamsAppAnalyticsContext), {
            data: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6527e90b2c09ca30$var$TeamProfileCardWithTrigger, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2tuSz.TeamsAppAnalyticsContext), {
        data: {
            source: 'teamProfileCardTrigger',
            attributes: {
                isRenderedByTrigger: true
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6527e90b2c09ca30$var$TeamProfileCardWithTrigger, props));
};
module.exports["TeamProfileCardWithTrigger"] = $6527e90b2c09ca30$export$d5b7952f9e2934c6;

});

parcelRegister("bhxnw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lUcpS = parcelRequire("lUcpS");


var $7iexr = parcelRequire("7iexr");

const $bbf18581332c4418$export$cd1a7849ca36cc69 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $7iexr.getPageTime)();
        $[0] = t0;
    } else t0 = $[0];
    const openTimeRef = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] !== fireEvent) {
        t1 = (eventKey, generator)=>{
            const duration = (0, $7iexr.getPageTime)() - openTimeRef.current;
            const attributes = generator(duration);
            fireEvent(eventKey, attributes);
        };
        $[1] = fireEvent;
        $[2] = t1;
    } else t1 = $[2];
    const fireAnalyticsWithDuration = t1;
    return fireAnalyticsWithDuration;
} : ()=>{
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const openTimeRef = (0, $cozmU.useRef)((0, $7iexr.getPageTime)());
    const fireAnalyticsWithDuration = (0, $cozmU.useCallback)((eventKey, generator)=>{
        const duration = (0, $7iexr.getPageTime)() - openTimeRef.current;
        const attributes = generator(duration);
        fireEvent(eventKey, attributes);
    }, [
        fireEvent
    ]);
    return fireAnalyticsWithDuration;
};
module.exports["useAnalyticsEventsWithDuration"] = $bbf18581332c4418$export$cd1a7849ca36cc69;

});

parcelRegister("7iexr", function(module, exports) {
const $443c6ad1469f1284$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $443c6ad1469f1284$var$performanceAvailable = $443c6ad1469f1284$var$isPerformanceAvailable();
const $443c6ad1469f1284$var$initialPageTime = Date.now();
const $443c6ad1469f1284$export$e9faea7c41053334 = ()=>{
    if ($443c6ad1469f1284$var$performanceAvailable) return performance.now();
    return Date.now() - $443c6ad1469f1284$var$initialPageTime;
};
module.exports["getPageTime"] = $443c6ad1469f1284$export$e9faea7c41053334;

});

parcelRegister("iVhFD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $iADqb = parcelRequire("iADqb");

const $3c27d9a50159047f$var$fetchPolicyDEPRECATED = 'network-only';
const $3c27d9a50159047f$var$fetchPolicy = 'store-or-network';

const $3c27d9a50159047f$export$6333901e831d7af0 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("bI2uc")), {
        moduleId: "16a28722",
        moduleName: "TeamProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'team-profile-card-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId, teamId: teamId })=>({
            queries: {
                queryRef: {
                    parameters: $iADqb.default,
                    variables: {
                        cloudId: cloudId,
                        teamId: teamId
                    },
                    options: {
                        fetchPolicy: (0, $iDrrr.fg)('ptc-fix-rate-limiting-on-profile-card') ? $3c27d9a50159047f$var$fetchPolicy : $3c27d9a50159047f$var$fetchPolicyDEPRECATED
                    }
                }
            }
        })
});
module.exports["entryPoint"] = $3c27d9a50159047f$export$6333901e831d7af0;

});

parcelRegister("iADqb", function(module, exports) {
/**
 * @generated SignedSource<<800005a0d7d5e830fd57fb6987a2c350>>
 * @relayHash f94e0154d1407d259dba5bb6e81bd540
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 846bdae3aac3d1d3d3d0174d1e98719c7143a7d8535d6b324d003827c39b285f
const $a8dc9040020a5ef9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "teamId"
        },
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TeamProfileCardEntryPointQuery",
            "selections": [
                {
                    "concreteType": "TeamQuery",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "teamV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "TeamProfileCardRelay_AtlassianTeamProfilecard"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TeamProfileCardEntryPointQuery",
            "selections": [
                {
                    "concreteType": "TeamQuery",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "teamV2",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "smallHeaderImageUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "smallAvatarImageUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isVerified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                {
                                    "concreteType": "TeamMemberConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TeamMemberV2",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "member",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "846bdae3aac3d1d3d3d0174d1e98719c7143a7d8535d6b324d003827c39b285f",
            "metadata": {},
            "name": "TeamProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a8dc9040020a5ef9$var$node.hash = "c9412d7c2df6f5eec001d802dbedc65d";
var $a8dc9040020a5ef9$export$2e2bcd8739ae039 = $a8dc9040020a5ef9$var$node;
module.exports["default"] = $a8dc9040020a5ef9$export$2e2bcd8739ae039;

});

parcelRegister("bI2uc", function(module, exports) {

let $8865bb6e82e68d05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8865bb6e82e68d05$var$load("fWgnv"),
    $8865bb6e82e68d05$var$load("9uywJ"),
    $8865bb6e82e68d05$var$load("auRBc"),
    $8865bb6e82e68d05$var$load("6wr18"),
    $8865bb6e82e68d05$var$load("gAvuV"),
    $8865bb6e82e68d05$var$load("6AlVx"),
    $8865bb6e82e68d05$var$load("6SP1J"),
    $8865bb6e82e68d05$var$load("6aqkL"),
    $8865bb6e82e68d05$var$load("7oAXW"),
    $8865bb6e82e68d05$var$load("7Fcep"),
    $8865bb6e82e68d05$var$load("4x9Jx"),
    $8865bb6e82e68d05$var$load("7EorR"),
    $8865bb6e82e68d05$var$load("96waY"),
    $8865bb6e82e68d05$var$load("ffEVr"),
    $8865bb6e82e68d05$var$load("jZMUd"),
    $8865bb6e82e68d05$var$load("cuWsK"),
    $8865bb6e82e68d05$var$load("35yiN"),
    $8865bb6e82e68d05$var$load("hhss7"),
    $8865bb6e82e68d05$var$load("Wowvf"),
    $8865bb6e82e68d05$var$load("4Njle")
]).then(()=>parcelRequire('arqiK'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("dvJQW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $epqQM = parcelRequire("epqQM");

const $e0d9f6eb351a6a5b$var$styles = {
    wrapper: "_2rko18qm _y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1bsb1gwv",
    text: "_syaz1rpy _19pku2gc"
};
/**
 * CardError component to display an error message when team information cannot be retrieved.
 */ const $e0d9f6eb351a6a5b$export$f7f7efdefcc02999 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CardError() {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($e0d9f6eb351a6a5b$var$styles.wrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epqQM.ErrorIllustration), null);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            weight: "semibold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e0d9f6eb351a6a5b$var$messages.title));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t0,
            testId: "team-profilecard-error",
            backgroundColor: "elevation.surface.overlay"
        }, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e0d9f6eb351a6a5b$var$styles.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e0d9f6eb351a6a5b$var$messages.text)));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function CardError() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0d9f6eb351a6a5b$var$styles.wrapper),
        testId: "team-profilecard-error",
        backgroundColor: "elevation.surface.overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epqQM.ErrorIllustration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e0d9f6eb351a6a5b$var$messages.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0d9f6eb351a6a5b$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e0d9f6eb351a6a5b$var$messages.text)));
};
const $e0d9f6eb351a6a5b$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    text: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    }
});
module.exports["CardError"] = $e0d9f6eb351a6a5b$export$f7f7efdefcc02999;

});

parcelRegister("epqQM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $1c64433aaa24640e$export$e0319f52fc2380b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            fillOpacity: "0.01"
        });
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
            fill: "url(#paint0_linear)"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.6",
            d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
            fill: "#C1C7D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.6",
            d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
            fill: "#C1C7D0"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.6",
            d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
            fill: "#B3BAC5"
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.6",
            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
            fill: "#B3BAC5"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0)"
        }, t0, t1, t2, t3, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            opacity: "0.6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.6",
            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
            fill: "#B3BAC5"
        })));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint0_linear",
            x1: "26.1692",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#C1C7D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.297",
            stopColor: "#C6CBD4",
            stopOpacity: "0.8812"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.6301",
            stopColor: "#D3D7DE",
            stopOpacity: "0.748"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.9795",
            stopColor: "#E9EBEF",
            stopOpacity: "0.6082"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: "0.6"
        }));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "42",
            height: "53",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "white"
        }))));
        $[7] = t7;
    } else t7 = $[7];
    return t7;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "var(--ds-surface-overlay, #FFFFFF)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
};
module.exports["ErrorIllustration"] = $1c64433aaa24640e$export$e0319f52fc2380b1;

});

parcelRegister("54JrL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");

const $c29474053ba97220$var$styles = {
    wrapper: "_2rko18qm _1reo15vq _18m915vq _1bsb1gwv _kqswh2mm",
    header: "_4t3i12am _1bsb1osq _13li18qm _qrwq18qm",
    content: "_1rjc1ejb _18zr1ejb _1e0c1txw _2lx21bp4 _1tke1w81",
    spinner: "_y3gn1h6o _19pk1jfw _otyr1jfw"
};
/**
 * CardLoading component to display a loading state while team information is being fetched.
 */ const $c29474053ba97220$export$5d25853fd6bdf402 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CardLoading() {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($c29474053ba97220$var$styles.wrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($c29474053ba97220$var$styles.header),
            backgroundColor: "color.background.neutral"
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $w6R6I.cx)($c29474053ba97220$var$styles.content);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $w6R6I.cx)($c29474053ba97220$var$styles.spinner);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t0,
            backgroundColor: "elevation.surface.overlay",
            testId: "team-profilecard"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3,
            testId: "team-profilecard-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null))));
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function CardLoading() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c29474053ba97220$var$styles.wrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c29474053ba97220$var$styles.header),
        backgroundColor: "color.background.neutral"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c29474053ba97220$var$styles.content)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c29474053ba97220$var$styles.spinner),
        testId: "team-profilecard-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null))));
};
module.exports["CardLoading"] = $c29474053ba97220$export$5d25853fd6bdf402;

});

parcelRegister("5Vf10", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $f9fcf6cb3fc873ae$var$styles = {
    trigger: "_kkk2n7od _1e0c1nu9"
};
const $f9fcf6cb3fc873ae$export$5f75736074ffd31e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { trigger: trigger, triggerProps: triggerProps, children: children } = t0;
    const isNonInteractiveHoverTriggerEnabled = (0, $iDrrr.fg)("townsquare_a11y_team_profilecard");
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every($f9fcf6cb3fc873ae$var$_temp) : trigger === "hover";
    const useNonInteractiveHoverTrigger = isNonInteractiveHoverTriggerEnabled && hoverOnlyTrigger;
    if (useNonInteractiveHoverTrigger) {
        let nonDialogTriggerProps;
        if ($[0] !== triggerProps) {
            const { "aria-expanded": _ariaExpanded, ...t1 } = triggerProps;
            nonDialogTriggerProps = t1;
            $[0] = triggerProps;
            $[1] = nonDialogTriggerProps;
        } else nonDialogTriggerProps = $[1];
        let t1;
        if ($[2] !== children || $[3] !== nonDialogTriggerProps) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                ...nonDialogTriggerProps,
                testId: "team-profilecard-trigger-wrapper",
                xcss: $f9fcf6cb3fc873ae$var$styles.trigger
            }, children);
            $[2] = children;
            $[3] = nonDialogTriggerProps;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    if ((0, $iDrrr.fg)("platform_create_work_item_modernization")) {
        const handleKeyDownCapture = $f9fcf6cb3fc873ae$var$_temp2;
        let spanTriggerProps;
        if ($[5] !== triggerProps) {
            const { "aria-expanded": _ariaExpanded_0, ...t1 } = triggerProps;
            spanTriggerProps = t1;
            $[5] = triggerProps;
            $[6] = spanTriggerProps;
        } else spanTriggerProps = $[6];
        let t1;
        if ($[7] !== children || $[8] !== spanTriggerProps) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                onKeyDownCapture: handleKeyDownCapture
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                ...spanTriggerProps,
                testId: "team-profilecard-trigger-wrapper",
                xcss: $f9fcf6cb3fc873ae$var$styles.trigger
            }, children));
            $[7] = children;
            $[8] = spanTriggerProps;
            $[9] = t1;
        } else t1 = $[9];
        return t1;
    }
    let t1;
    if ($[10] !== children || $[11] !== triggerProps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...triggerProps,
            testId: "team-profilecard-trigger-wrapper",
            xcss: $f9fcf6cb3fc873ae$var$styles.trigger
        }, children);
        $[10] = children;
        $[11] = triggerProps;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ trigger: trigger, triggerProps: triggerProps, children: children })=>{
    const isNonInteractiveHoverTriggerEnabled = (0, $iDrrr.fg)('townsquare_a11y_team_profilecard');
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every((mode)=>mode === 'hover') : trigger === 'hover';
    const useNonInteractiveHoverTrigger = isNonInteractiveHoverTriggerEnabled && hoverOnlyTrigger;
    if (useNonInteractiveHoverTrigger) {
        const { 'aria-expanded': _ariaExpanded, ...nonDialogTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            ...nonDialogTriggerProps,
            testId: "team-profilecard-trigger-wrapper",
            xcss: $f9fcf6cb3fc873ae$var$styles.trigger
        }, children);
    }
    if ((0, $iDrrr.fg)('platform_create_work_item_modernization')) {
        // Avoid invalid HTML: <span> wrapper prevents <button> from wrapping interactive children like <a>.
        // onKeyDownCapture intercepts Enter before popup fires, delegating to the inner <a> link instead.
        const handleKeyDownCapture = (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                const link = e.currentTarget.querySelector('a[href]');
                if (link) {
                    e.preventDefault();
                    e.stopPropagation();
                    link.click();
                }
            }
        }; // Strip aria-expanded: a plain <span> has no role, so aria-expanded would be invalid HTML.
        const { 'aria-expanded': _ariaExpanded_0, ...spanTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            onKeyDownCapture: handleKeyDownCapture
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            ...spanTriggerProps,
            testId: "team-profilecard-trigger-wrapper",
            xcss: $f9fcf6cb3fc873ae$var$styles.trigger
        }, children));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...triggerProps,
        testId: "team-profilecard-trigger-wrapper",
        xcss: $f9fcf6cb3fc873ae$var$styles.trigger
    }, children);
};
function $f9fcf6cb3fc873ae$var$_temp(mode) {
    return mode === "hover";
}
function $f9fcf6cb3fc873ae$var$_temp2(e) {
    if (e.key === "Enter" || e.key === " ") {
        const link = e.currentTarget.querySelector("a[href]");
        if (link) {
            e.preventDefault();
            e.stopPropagation();
            link.click();
        }
    }
}
module.exports["TeamProfileCardTrigger"] = $f9fcf6cb3fc873ae$export$5f75736074ffd31e;

});


//# sourceMappingURL=ProjectPanel.6a3ecaf5.js.map
